<template>
  <div class="content">
    <h2 class="pl-3">{{ father }} | Aspirantes a Banderas</h2>
    <v-row justify="end">
      <v-col md="auto">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="blue-grey" class="ma-2 white--text" fab v-on="on" @click="descargarPDF">
              <v-icon dark>mdi-cloud-download</v-icon>
            </v-btn>
          </template>
          <span>Descargar Planilla</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="alumnos"
      ref="lista_promedios"
      class="elevation-1 pa-3 ma-3"
      hide-default-footer
    >
      <!--<template v-slot:items="props">
        <td>{{props.index + 1}}</td>
        <td class="text-eft">{{ mayus(props.item.nombre_alumno) }}</td>
        <td class="text-left">{{ mayus(props.item.promedio) }}</td>
        <td class="text-left">{{ mayus(props.item.curso) }}</td>
      </template>-->
      <template v-slot:item.numero="{ item, index }">
        <td>{{ index + 1 }}</td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import API from "@/components/_config/conf";

export default {
  data() {
    return {
      headers: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "numero"
        },
        {
          text: "Alumno",
          align: "left",
          sortable: false,
          value: "nombre_alumno"
        },
        {
          text: "Promedio",
          sortable: false,
          value: "promedio"
        },
        {
          text: "Curso",
          sortable: false,
          value: "curso"
        }
      ],
      alumnos: []
    };
  },
  props: ["father"],
  mounted: function() {
    this.$emit("abanderados:mostrarOcultarPreload");
    let params = "parametro=bandera&curso=''";
    let resultado = API.enviar("get", "obtenerMejoresNota", params);
    resultado
      .then(result => {
        if (result.data.msj == "ok") this.alumnos = result.data.result;
        this.$emit("abanderados:mostrarOcultarPreload");
      })
      .catch(() => {
        //console.log("catch obtenerMateriasDeProfesor-> params: ", params);
      });
  },
  methods: {
    mayus(str) {
      let srt_result = API.ucFirst(str);
      return srt_result;
    },
    calcularIndiceTabla() {
      let indice = this.indiceTabla++;
      return indice;
    },
    descargarPDF: function() {
      console.log("descargarPDF Aspirante");
      window.open(API.PORT + API.PATH + "?funcion=descargarReporteAspirantes");
    }
  }
};
</script>

<style scoped>
.content {
  width: 100%;
}
</style>